/* Accessible dismissal for the desktop Bambini panel. Native details works without JS. */
document.addEventListener('keydown', event => {
  if (event.key !== 'Escape') return;
  const menu = document.querySelector('.promis-kids-menu[open]');
  if (menu) {
    menu.open = false;
    menu.querySelector('summary').focus();
  }
});
document.addEventListener('click', event => {
  document.querySelectorAll('.promis-kids-menu[open]').forEach(menu => {
    if (!menu.contains(event.target)) menu.open = false;
  });
});

(() => {
  const mobile = window.matchMedia('(max-width: 1023px)');
  let desktopAnchor;
  let scheduled = false;
  const placeLanguageSelector = () => {
    scheduled = false;
    const slot = document.querySelector('.promis-mobile-language__control');
    const header = document.querySelector('.promis-header .site-header__addons');
    if (!slot || !header) return;
    const selector = header.querySelector('.ht-tms-single-dropdown__container--language') || slot.querySelector('.ht-tms-single-dropdown__container--language') || document.querySelector('#Drawer-MobileNav .ht-tms-single-dropdown__container--language');
    if (!selector) return;
    if (mobile.matches) {
      if (slot.contains(selector)) return;
      if (header.contains(selector)) {
        desktopAnchor = document.createComment('language selector');
        selector.before(desktopAnchor);
      }
      slot.append(selector);
    } else if (!header.contains(selector)) {
      if (desktopAnchor?.isConnected) desktopAnchor.after(selector);
      else header.prepend(selector);
    }
  };
  const schedule = () => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(placeLanguageSelector);
  };
  const init = () => {
    placeLanguageSelector();
    new MutationObserver(schedule).observe(document.body, {childList: true, subtree: true});
    mobile.addEventListener('change', schedule);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once: true});
  else init();
})();
